import { CLEAN_ORDER_DATA, SELECT_ORDER_DATA } from "../types/orders.types";

const initialState = {
	order: {},
};

function orders(state = initialState, action) {
	switch (action.type) {
		case SELECT_ORDER_DATA:
			return {
				...state,
				order: action.payload.order,
			};
		case CLEAN_ORDER_DATA:
			return {
				order: {},
			};
		default:
			return state;
	}
}

export default orders;
